import { endpoints } from "../../services/endpoint.ts/endpoint";
import { URL } from "../../utils/contact";
import { getData } from "../api/action";

export const getSosReportPdf = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_PDF.url}`,
  });
  return response;
};

export const getSosReportExcel = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_EXCEL.url}`,
  });
  return response;
};

export const getDetail = async (id) => {
  const response = await getData({
    url: `${endpoints.GET_SOSREPORT.url}/${id}`,
  });
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

// 2024-12-27 추가
export const getPdfSummary = async (id) => {
  try {
    const backendUrl = process.env.REACT_APP_API_URL || URL;
    const response = await fetch(`${backendUrl}${endpoints.GET_PDF_SUMMARY.url}/${id}`, {
      headers: {
        'Accept': 'text/html',
        'Content-Type': 'text/html; charset=UTF-8'
      }
    });
    
    const htmlContent = await response.text();
    return {
      data: new Blob([htmlContent], { type: 'text/html;charset=UTF-8' }),
      headers: Object.fromEntries(response.headers.entries())
    };
  } catch (error) {
    console.error('getPdfSummary error:', error);
    throw error;
  }
};

// export const getHtmlView = async (username, fileName) => {
//   try {
//     const fileNameStr = Array.isArray(fileName) ? fileName[0] : fileName;
//     const backendUrl = process.env.REACT_APP_API_URL || URL;
//     const url = `${backendUrl}/api/file/html-view?username=${encodeURIComponent(username)}&fileName=${encodeURIComponent(fileNameStr)}`;
    
//     const response = await fetch(url);
    
//     if (response.status === 500) {
//       return { status: 500 };
//     }
    
//     if (!response.ok) {
//       return { status: response.status };
//     }
    
//     const newWindow = window.open(url, '_blank');
//     if (!newWindow) {
//       alert('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.');
//       return { status: 'popup_blocked' };
//     }
    
//     return { status: 200 };
    
//   } catch (error) {
//     console.error('에러 발생:', error);
//     return { status: 'error', error };
//   }
// };

export const getHtmlView = async (username, fileName) => {
  try {
    const fileNameStr = Array.isArray(fileName) ? fileName[0] : fileName;
    const backendUrl = process.env.REACT_APP_API_URL || URL;
    const url = `${backendUrl}/api/file/html-view?username=${encodeURIComponent(username)}&fileName=${encodeURIComponent(fileNameStr)}`;
    
    // 새 창 열기
    const newWindow = window.open('', '_blank', 'width=1200,height=800');
    if (!newWindow) {
      return { status: 'popup_blocked' };
    }
    
    // 로딩 표시
    newWindow.document.write(`
      <html>
        <head>
          <title>SOS Report Viewer</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
              background-color: #f5f5f5;
            }
            .loader {
              border: 5px solid #f3f3f3;
              border-top: 5px solid #3498db;
              border-radius: 50%;
              width: 50px;
              height: 50px;
              animation: spin 1s linear infinite;
              margin-right: 20px;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .container {
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .loading-text {
              margin-top: 20px;
              font-size: 18px;
              color: #333;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="loader"></div>
            <div class="loading-text">HTML 파일을 생성하는 중입니다...</div>
          </div>
        </body>
      </html>
    `);
    
    // 백엔드 API 호출
    const response = await fetch(url);
    
    if (response.status === 500) {
      newWindow.close();
      return { status: 500 };
    }
    
    if (!response.ok) {
      newWindow.close();
      return { status: response.status };
    }
    
    // // 응답 내용 가져오기
    // const content = await response.text();
    
    // // HTML 응답인 경우 직접 문서에 쓰기
    // if (response.headers.get('content-type')?.includes('text/html')) {
    //   newWindow.document.open();
    //   newWindow.document.write(content);
    //   newWindow.document.close();
    // } else {
    //   // URL이 반환된 경우 해당 URL로 이동
    //   newWindow.location.href = content;
    // }
    
    // 백엔드에서 생성된 HTML 파일의 URL로 리다이렉트
    const htmlUrl = await response.text();
    newWindow.location.href = htmlUrl;
    
    return { status: 200 };
    
  } catch (error) {
    console.error('에러 발생:', error);
    return { status: 'error', error };
  }
};
